import { getApiUrl, getAuthHeaders, handleApiResponse } from '../config/api';

export interface LogFilters {
  startDate?: string;
  endDate?: string;
  doctorId?: number;
  patientId?: number;
  status?: string;
  serviceType?: string;
  page?: number;
  limit?: number;
  search?: string;
}

export interface AppointmentLog {
  id: number;
  appointmentDate: string;
  appointmentTime: string;
  serviceType: string;
  status: string;
  patientName: string;
  patientAge: string;
  patientGender: string;
  problemDescription: string;
  totalAmount: number;
  isActive: boolean;
  isUpcoming: boolean;
  doctor: {
    id: number;
    name: string;
    email: string;
    phone: string;
  } | null;
  patient: {
    id: number;
    name: string;
    email: string;
    phone: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}

export interface LogsResponse {
  success: boolean;
  data: {
    appointments?: AppointmentLog[];
    pagination?: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
  message?: string;
}

class LogsService {
  private buildQueryString(filters: LogFilters): string {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.doctorId) params.append('doctorId', filters.doctorId.toString());
    if (filters.patientId) params.append('patientId', filters.patientId.toString());
    if (filters.status) params.append('status', filters.status);
    if (filters.serviceType) params.append('serviceType', filters.serviceType);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.search) params.append('search', filters.search);
    return params.toString();
  }

  async getAppointmentLogs(filters: LogFilters = {}): Promise<LogsResponse> {
    const queryString = this.buildQueryString(filters);
    const url = getApiUrl(`/admin/logs/appointments${queryString ? `?${queryString}` : ''}`);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
    });
    
    return handleApiResponse(response);
  }
}

export const logsService = new LogsService();
